/* [BD feat] FAQ Section — tab switching + icon-curve fill sync (Web Component) */
class BdFaqTabs extends HTMLElement {
  constructor() {
    super();
    this._boundOnTab1Click = null;
    this._boundOnTab2Click = null;
  }

  connectedCallback() {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const button1 = this.querySelector('#faq-button-1-' + sectionId);
    const button2 = this.querySelector('#faq-button-2-' + sectionId);
    const content1 = this.querySelector('#bd-faq__content1-' + sectionId);
    const content2 = this.querySelector('#bd-faq__content2-' + sectionId);
    const tabsContainer = this.querySelector('.bd-faq-section__tabs');

    if (!button1 || !button2 || !content1 || !content2) return;

    /* [BD feat] FAQ tab icon-curve — fill + stroke from Liquid (data-*), synced on tab switch */
    const fillInactive = tabsContainer?.dataset.tabFill || '#FAFAF0';
    const fillActive = tabsContainer?.dataset.tabActiveFill || '#00442A';
    const strokeInactive = tabsContainer?.dataset.tabStrokeInactive || '#E5EBDC';
    const strokeActive = tabsContainer?.dataset.tabStrokeActive || '#00442A';

    const syncIconCurveState = () => {
      const curve1 = button1.closest('bd-icon-curve');
      const curve2 = button2.closest('bd-icon-curve');
      const b1Active = button1.classList.contains('bd-faq-section__tabs--btn-active');
      const b2Active = button2.classList.contains('bd-faq-section__tabs--btn-active');
      if (curve1) {
        curve1.dataset.fill = b1Active ? fillActive : fillInactive;
        curve1.dataset.stroke = b1Active ? strokeActive : strokeInactive;
      }
      if (curve2) {
        curve2.dataset.fill = b2Active ? fillActive : fillInactive;
        curve2.dataset.stroke = b2Active ? strokeActive : strokeInactive;
      }
    };

    const closeAll = () => {
      const details = this.querySelectorAll('details');
      if (details && details.length > 0) {
        details.forEach((detail) => detail.removeAttribute('open'));
      }
    };

    this._boundOnTab1Click = () => {
      button1.classList.add('bd-faq-section__tabs--btn-active');
      button2.classList.remove('bd-faq-section__tabs--btn-active');
      content1.classList.add('bd-faq-section__content--active');
      content2.classList.remove('bd-faq-section__content--active');
      syncIconCurveState();
      closeAll();
    };

    this._boundOnTab2Click = () => {
      button2.classList.add('bd-faq-section__tabs--btn-active');
      button1.classList.remove('bd-faq-section__tabs--btn-active');
      content2.classList.add('bd-faq-section__content--active');
      content1.classList.remove('bd-faq-section__content--active');
      syncIconCurveState();
      closeAll();
    };

    button1.addEventListener('click', this._boundOnTab1Click);
    button2.addEventListener('click', this._boundOnTab2Click);
    /* [BD feat] FAQ tab icon-curve — end */
  }

  disconnectedCallback() {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const button1 = this.querySelector('#faq-button-1-' + sectionId);
    const button2 = this.querySelector('#faq-button-2-' + sectionId);

    if (button1 && this._boundOnTab1Click) {
      button1.removeEventListener('click', this._boundOnTab1Click);
    }
    if (button2 && this._boundOnTab2Click) {
      button2.removeEventListener('click', this._boundOnTab2Click);
    }

    this._boundOnTab1Click = null;
    this._boundOnTab2Click = null;
  }
}

if (!customElements.get('bd-faq-tabs')) {
  customElements.define('bd-faq-tabs', BdFaqTabs);
}
/* [BD feat] FAQ Section — end */
